import { service } from '../../../../helpers/http' 

export const ActionGetTeacherPositionCategories = ({ dispatch }, payload) => { 
    return service({
        module: 'teacherPositionCategory',
        action: 'getTeacherPositionCategories',
        payload: payload
    })
}

export const ActionPostTeacherPositionCategories = ({ dispatch }, payload) => {

    return service({
        module: 'teacherPositionCategory',
        action: 'postTeacherPositionCategories',
        payload: payload
    })
    
}

export const ActionPutTeacherPositionCategories = ({ dispatch }, payload) => {

    return service({
        module: 'teacherPositionCategory',
        action: 'putTeacherPositionCategories',
        payload: payload
    })
    
}

export const ActionDeleteTeacherPositionCategories = ({ dispatch }, payload) => {

    return service({
        module: 'teacherPositionCategory',
        action: 'deleteTeacherPositionCategories',
        payload: payload
    })
    
}
